var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0167 0.0900925L0.341559 7.40034C-0.153416 7.68466 -0.090519 8.37358 0.401721 8.58136L3.30867 9.80064L11.1654 2.87859C11.3158 2.74464 11.5291 2.94967 11.4006 3.1055L4.81274 11.1293V13.33C4.81274 13.9752 5.59212 14.2294 5.97497 13.762L7.71149 11.6487L11.1189 13.0758C11.5072 13.2398 11.9502 12.9965 12.0213 12.5782L13.9903 0.768081C14.0833 0.215848 13.4898 -0.18329 13.0167 0.0900925Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paperPlane.c4f0e0c78fa253ab793f9d72e38d936e.svg";
export { ForwardRef as ReactComponent };